import {S} from './strings.mjs';
import {isWide} from './layout.mjs';
import {externalAnchors} from './links.mjs';

export const creditsPosition = desktop => desktop ? 'bottom-right' : 'bottom-left';
export const COLLAPSE_DELAY = 8000;

// One initial deadline per page load; reopening never starts another countdown.
export function attributionState(render, {timers = globalThis} = {}) {
  let expanded = true;
  const deadline = timers.setTimeout(() => update(false), COLLAPSE_DELAY);
  function update(next) {
    timers.clearTimeout(deadline);
    if (expanded === next) return;
    expanded = next; render(expanded);
  }
  render(expanded);
  return {
    get expanded() { return expanded; },
    interact(event) { if ((event?.originalEvent ?? event)?.isTrusted === true) update(false); },
    toggle() { update(!expanded); },
    stop() { timers.clearTimeout(deadline); },
  };
}

export function installAttribution(map, {desktop = () => isWide(),
  timers = globalThis} = {}) {
  let position = null, redocking = false, state, button, text;
  const mapEvents = ['dragstart', 'zoomstart', 'click'];
  const interact = event => state.interact(event);
  const wheel = event => { if (map.getCanvasContainer().contains(event.target)) interact(event); };
  const paint = expanded => {
    text.hidden = !expanded;
    button.setAttribute('aria-expanded', String(expanded));
    button.dataset.i18nAria = expanded ? 'attributionHide' : 'attributionShow';
    button.setAttribute('aria-label', S[button.dataset.i18nAria]);
  };
  const control = {
    onAdd() {
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.className = 'maplibregl-ctrl map-credits';
        text = document.createElement('span'); text.id = 'map-credits-text';
        text.className = 'map-credits-text'; text.innerHTML = externalAnchors(S.attribution);
        button = document.createElement('button'); button.type = 'button';
        button.className = 'map-credits-toggle';
        button.setAttribute('aria-controls', text.id);
        button.innerHTML = '<span aria-hidden="true">i</span>';
        button.addEventListener('click', () => state.toggle());
        this.container.append(text, button);
        // Credits and links must not count as canvas interactions.
        for (const name of ['click', 'dblclick', 'pointerdown', 'touchstart', 'wheel'])
          this.container.addEventListener(name, event => event.stopPropagation());
        state = attributionState(paint, {timers});
      }
      for (const name of mapEvents) map.on(name, interact);
      map.getContainer().addEventListener('wheel', wheel, {passive: true});
      return this.container;
    },
    setStyle() { text.innerHTML = externalAnchors(S.attribution); paint(state.expanded); },
    onRemove() {
      for (const name of mapEvents) map.off(name, interact);
      map.getContainer().removeEventListener('wheel', wheel);
      if (!redocking) state.stop();
      this.container.remove();
    },
    place() {
      const next = creditsPosition(desktop());
      if (next === position) return;
      redocking = true;
      if (position) map.removeControl(control);
      position = next; map.addControl(control, next);
      // The flag opens into the map from the actual dock, independent of disclosure.
      control.container.dataset.position = position;
      redocking = false;
    },
    get position() { return position; },
  };
  control.place();
  return control;
}
